import React from "react";
import { Box, Center, Flex, Image, Text } from "@chakra-ui/react";
import NoChatFoundImg from "@assets/images/no-chats-found.png";
import { CustonButtom } from "../common/button/customButton";
import { StartNewChat } from "@assets/icons/startNewChat";
import { useTranslation } from "react-i18next";
import useSidebar from "@root/hooks/useSidebar";

export const EmptyComponent: React.FC<CenteredMessageProps> = ({
  message,
  desc,
  onClick,
}) => {
  const { t } = useTranslation("common");
  const { clickOnAdd } = useSidebar();

  return (
    <Flex height="100vh" justifyContent={"center"} alignItems={"center"}>
      <Flex
        background={"white"}
        textAlign={"center"}
        boxShadow={"0px 20px 20px 0px #00000033"}
        border={"1px solid"}
        borderColor={"#337CC1"}
        borderRadius={"8px"}
        padding={"25px 70px"}
        flexDir={"column"}
        alignItems={"center"}
        gap={"8px"}
      >
        <Flex>
          <Image src={NoChatFoundImg} width={"140px"} />
        </Flex>
        <Text fontSize="18px" color="black" mt={"10px"}>
          {message}
        </Text>
        <Text fontSize="16px" color="gray.500" fontStyle={"16px"} mb="10px">
          {desc}
        </Text>
        {/* <CustonButtom
          startadornicon={<StartNewChat />}
          gap={"12px"}
          height={"39px"}
          border={"1px solid"}
          borderColor={"border.100"}
          bg={"purple.purpleGradient"}
          width={"fit-content"}
          text={t("translate.addChat")}
          justifyContent={"center"}
          alignItems={"center"}
          onClick={() => {
            clickOnAdd();
          }}
          borderRadius={"8px"}
        /> */}
      </Flex>
    </Flex>
  );
};
